<script lang="ts">
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import SheetProductTile from '@tilelist/layouts/experiments/e3966/sheet-product-tile/SheetProductTile.svelte';
    import { fetchTiles, inspirationTilesState } from './ComboSheetStore.svelte.ts';

    interface Props {
        comboId: string;
        moodImage: string;
        variations: string[];
    }

    let { comboId, moodImage, variations }: Props = $props();

    const wiring = injectWiring();

    const onSheetOpen = () => fetchTiles(wiring.variationLoadingService, variations, comboId);
</script>

<oc-sheet-v1
    id="reptile-inspiration-combination-sheet"
    onoc-sheet-before-open={onSheetOpen}
    onoc-sheet-open={() => wiring.trackingService?.trackListLayer('combo')}
    hide-header
    full-height
    no-content-padding
>
    <div class="reptile-combo-sheet__header">
        <picture class="reptile-combo-sheet__mood-picture">
            <img
                class="reptile-combo-sheet__mood-image"
                src={moodImage}
                alt="Beispielbild zur vorgeschlagenen Produktkombination"
            />
        </picture>
    </div>
    <section class="reptile-combo-sheet__content">
        <h2 class="reptile-combo-sheet__headline">Perfekt kombiniert</h2>
        <ul class="reptile-combo-sheet__tiles">
            {#if inspirationTilesState.isLoading}
                {#each Array.from({ length: 4 }) as _, i (i)}
                    <li class="reptile-combo-sheet__tile reptile-combo-sheet__tile--skeleton">
                        <oc-skeleton-v1 variant="rectangle" border-radius="0px"></oc-skeleton-v1>
                    </li>
                {/each}
            {:else}
                {#each inspirationTilesState.tiles as variation, i (variation.variationId)}
                    <li class="reptile-combo-sheet__tile reptile-combo-sheet__tile--loaded">
                        <SheetProductTile
                            {variation}
                            position={i + 1}
                            onTileClick={(event) => wiring.trackingService?.trackComboProductClick(event, i + 1)}
                        />
                    </li>
                {/each}
            {/if}
        </ul>
    </section>
</oc-sheet-v1>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens' as tokens;

    .reptile-combo-sheet__header,
    .reptile-combo-sheet__mood-picture,
    .reptile-combo-sheet__mood-image {
        width: 100%;
    }

    .reptile-combo-sheet__headline {
        padding: tokens.$oc-semantic-spacing-absolute-100 tokens.$oc-semantic-spacing-absolute-75
            tokens.$oc-semantic-spacing-absolute-50 tokens.$oc-semantic-spacing-absolute-75;
        font: tokens.$oc-semantic-font-headline-100;
    }

    .reptile-combo-sheet__tiles {
        display: grid;
        grid-template-columns: 0 repeat(2, 1fr) 0;
        gap: 4px;
    }

    .reptile-combo-sheet__tile--skeleton {
        position: relative;
        overflow: hidden;
        aspect-ratio: 3/4;
    }

    .reptile-combo-sheet__tile--skeleton oc-skeleton-v1 {
        position: absolute;
        inset: 0;
    }

    .reptile-combo-sheet__tile:nth-child(odd) {
        grid-column: 2;
    }

    .reptile-combo-sheet__tile:nth-child(even) {
        grid-column: 3;
    }

    .reptile-combo-sheet__mood-image {
        min-height: 30vh;
        max-height: 60vh;
        object-fit: cover;
    }

    @keyframes reptile-combo-sheet-fade-in {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }

    .reptile-combo-sheet__tile--loaded {
        animation: reptile-combo-sheet-fade-in tokens.$oc-semantic-duration-short-150 ease-out;
    }

    @media (prefers-reduced-motion: reduce) {
        .reptile-combo-sheet__tile--loaded {
            animation: none;
        }
    }
</style>
